import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import { zIndex, colors } from '@spaceshipapp/cambridge';
import { Sheet } from '../Select/styled';

export const cardStyle = css`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: ${zIndex.DROPDOWN + 1};
`;

export const mobileListStyle = css`
  height: 100%;
  margin: 1em -1em 0 -1em;
  overflow: auto;

  li {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
`;

export const comboboxStyle = css`
  display: flex;
`;

export const inputStyle = css`
  flex-grow: 1;
`;

export const StyledSheet = styled(Sheet)`
  padding: 0.5rem 0; /* TODO: fix padding */
`;

export const SubLabel = styled.span`
  color: ${colors.subtext};
`;

export const Placeholder = styled.li`
  padding: 1em;
  background-color: ${colors.surface};
`;

export const Wrapper = styled.div`
  position: relative;
`;
